import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-toggle-view-icon',
  standalone: true,
  templateUrl: './toggle-view-icon.component.html',
  styleUrls: ['./toggle-view-icon.component.scss']
})
export class ToggleViewIconComponent {
  @Input() width: number | string = 20;
  @Input() height: number | string = 20;
}
